import TableAntd from '../../../components/TableAntd'
import { Button } from 'antd'
import Search from '../../../components/SearchFilter'
import Buttonbar from '../../../components/ButtonBar'
import uselaunchgoodshooks from './hooks'
import styles from './styles.module.scss'
import { formatterPrice } from '@/tools/util'

// 我发起的审核-商品
const Launchgoods = () => {
  const {
    dataSource,
    pages,
    onSearch,
    onChange,
    onJump,
    onRefresh,
    nopassSwitch,
    onRecall,
  } = uselaunchgoodshooks()
  const listColumn = [
    {
      key: 'tempCode',
      title: '编码',
      width: 100,
    },
    {
      key: 'name',
      title: '名称',
      width: 100,
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      title: '型号规格',
      width: 100,
    },
    {
      key: 'unitName',
      title: '单位',
      width: 100,
    },
    {
      key: 'purchasePrice',
      title: '参考供货价',
      width: 100,
      render: (text: string) => (text ? formatterPrice(text) : '-'),
    },
    {
      key: 'stateValue',
      title: '审核状态',
      width: 100,
      render: (text: any) => {
        return <span>{text || '-'}</span>
      },
    },
    {
      key: 'checkMan',
      title: '当前审核人',
      width: 100,
      render: (text: any) => {
        return <span>{text || '-'}</span>
      },
    },
    {
      key: 'checkTime',
      title: '审核时间',
      width: 100,
    },
    {
      key: 'des',
      title: '审核说明',
      width: 100,
    },
    {
      key: 'operation',
      title: '操作栏',
      width: 100,
      render: (text: any, record: any) => {
        return (
          <>
            {record.stateValue === '驳回' || record.stateValue === '撤回' ? (
              <Button type="link" onClick={() => nopassSwitch(record.id)}>
                放弃
              </Button>
            ) : record.stateValue === '新增审核中' ||
              record.stateValue === '修改审核中' ? (
              <Button type="link" onClick={() => onRecall(record.id)}>
                撤回
              </Button>
            ) : (
              '-'
            )}
          </>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'tempCode',
          'name',
          'brand',
          'model',
          'unitCode',
          'checkState',
          // 'checkMan',
          'auditStartDate',
          'auditEndDate',
        ]}
        onSearch={onSearch}
        keyName="LAUNCHGOODS"
        ScreenKey="LAUNCHGOODS"
      />
      <div style={{ padding: '10px 10px' }}>
        {/* 操作栏 */}
        <Buttonbar onRefresh={onRefresh}></Buttonbar>
        <TableAntd
          loading={dataSource.loading}
          dataSource={dataSource.data}
          listColumn={listColumn}
          showSort
          showSize
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
        />
      </div>
    </div>
  )
}

export default Launchgoods
import TableAntd from '../../../components/TableAntd'
import { Button } from 'antd'
import Search from '../../../components/SearchFilter'
import Buttonbar from '../../../components/ButtonBar'
import uselaunchgoodshooks from './hooks'
import styles from './styles.module.scss'
import { formatterPrice } from '@/tools/util'

// 我发起的审核-商品
const Launchgoods = () => {
  const {
    dataSource,
    pages,
    onSearch,
    onChange,
    onJump,
    onRefresh,
    nopassSwitch,
    onRecall,
  } = uselaunchgoodshooks()
  const listColumn = [
    {
      key: 'tempCode',
      title: '编码',
      width: 100,
    },
    {
      key: 'name',
      title: '名称',
      width: 100,
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brand',
      title: '品牌',
    },
    {
      key: 'model',
      title: '型号规格',
      width: 100,
    },
    {
      key: 'unitName',
      title: '单位',
      width: 100,
    },
    {
      key: 'purchasePrice',
      title: '参考供货价',
      width: 100,
      render: (text: string) => (text ? formatterPrice(text) : '-'),
    },
    {
      key: 'stateValue',
      title: '审核状态',
      width: 100,
      render: (text: any) => {
        return <span>{text || '-'}</span>
      },
    },
    {
      key: 'checkMan',
      title: '当前审核人',
      width: 100,
      render: (text: any) => {
        return <span>{text || '-'}</span>
      },
    },
    {
      key: 'checkTime',
      title: '审核时间',
      width: 100,
    },
    {
      key: 'des',
      title: '审核说明',
      width: 100,
    },
    {
      key: 'operation',
      title: '操作栏',
      width: 100,
      render: (text: any, record: any) => {
        return (
          <>
            {record.stateValue === '驳回' || record.stateValue === '撤回' ? (
              <Button type="link" onClick={() => nopassSwitch(record.id)}>
                放弃
              </Button>
            ) : record.stateValue === '新增审核中' ||
              record.stateValue === '修改审核中' ? (
              <Button type="link" onClick={() => onRecall(record.id)}>
                撤回
              </Button>
            ) : (
              '-'
            )}
          </>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'tempCode',
          'name',
          'brand',
          'model',
          'unitCode',
          'checkState',
          // 'checkMan',
          'auditStartDate',
          'auditEndDate',
        ]}
        onSearch={onSearch}
        keyName="LAUNCHGOODS"
        ScreenKey="LAUNCHGOODS"
      />
      <div style={{ padding: '10px 10px' }}>
        {/* 操作栏 */}
        <Buttonbar onRefresh={onRefresh}></Buttonbar>
        <TableAntd
          loading={dataSource.loading}
          dataSource={dataSource.data}
          listColumn={listColumn}
          showSort
          showSize
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
        />
      </div>
    </div>
  )
}

export default Launchgoods
